/* eslint-disable */
import dayjs from 'dayjs';

// defaults to 2 decimal places, always convert to percentage by multiplying by 100
export const parsePercentage = (percentage, decimals = 2) => {
  const fixedPercentage = (parseFloat(percentage) * 100).toFixed(decimals);
  if (fixedPercentage === 'NaN' || percentage === 0) {
    return 'N/A';
  }
  else {
    return `${fixedPercentage}%`;
  }
};

export const formatMonthData = (date, returns) => {
  // assuming returns and yields has the same lengths and same dates
  // RETURNS
  const currentMonth = { Date: date, targetEnrollment: [], static: [], customized: [] };
  returns.forEach(returnItem => {
    const customizedReturn = {
      Name: returnItem.Name,
      Ticker: returnItem.Ticker,
      SortOrder: returnItem.SortOrder,
      InceptionDate: dayjs(returnItem.InceptionDate).format('MM/DD/YYYY'),
      OneMonth: parsePercentage(returnItem.OneMonth),
      ThreeMonth: parsePercentage(returnItem.ThreeMonth),
      YTD: parsePercentage(returnItem.YTD),
      OneYear: parsePercentage(returnItem.OneYear),
      ThreeYear: parsePercentage(returnItem.ThreeYear),
      FiveYear: parsePercentage(returnItem.FiveYear),
      TenYear: parsePercentage(returnItem.TenYear),
      SinceInception: parsePercentage(returnItem.SinceInception)
    };

    if (returnItem.OptionType === 'T') {
      currentMonth.targetEnrollment.push(customizedReturn);
    }
    else if (returnItem.OptionType === 'S') {
      currentMonth.static.push(customizedReturn);
    }
    else if (returnItem.OptionType === 'C') {
      currentMonth.customized.push(customizedReturn);
    }
  });

  return currentMonth;
};

export const formatDropDownDate = (date) => {
  if (date === undefined || date === null || date === '') {
    return null;
  }
  else {
    let month;
    const day = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const year = date.getFullYear();
    switch (date.getMonth()) {
      case 0:
        month = 'January';
        break;
      case 1:
        month = 'February';
        break;
      case 2:
        month = 'March';
        break;
      case 3:
        month = 'April';
        break;
      case 4:
        month = 'May';
        break;
      case 5:
        month = 'June';
        break;
      case 6:
        month = 'July';
        break;
      case 7:
        month = 'August';
        break;
      case 8:
        month = 'September';
        break;
      case 9:
        month = 'October';
        break;
      case 10:
        month = 'November';
        break;
      case 11:
        month = 'December';
        break;
      default:
        break;
    }
    return `${month} ${day}, ${year}`;
  }
};
